import React from "react";

function DocProfile({ contract, account }) {
  return <div>DocProfile</div>;
}

export default DocProfile;
